import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { InsuranceCalculatorTool } from '@/components/InsuranceCalculatorTool';
import { AIAssistantWidget } from '@/components/AIAssistantWidget';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const InsuranceCalculator = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-b from-primary-light/30 to-background">
        <div className="container mx-auto px-6">
          <div className="max-w-2xl mx-auto text-center mb-12">
            <h1 className="text-4xl md:text-6xl font-bold text-foreground mb-6">
              Insurance Calculator
            </h1>
            <p className="text-xl text-muted-foreground">
              Calculate exactly how much life insurance coverage you need based on your unique financial situation.
            </p>
          </div>
        </div>
      </section>

      {/* Calculator */}
      <section className="py-20">
        <div className="container mx-auto px-6">
          <InsuranceCalculatorTool />
        </div>
      </section>

      {/* Next Steps */}
      <section className="py-20 bg-primary-light/30">
        <div className="container mx-auto px-6">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-6">
              Ready for Your Personalized Quote?
            </h2>
            <p className="text-xl text-muted-foreground mb-8">
              Now that you know how much coverage you need, get personalized quotes from top-rated carriers.
            </p>
            <Link to="/">
              <Button size="lg" variant="hero">
                Get My Quote Now
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
      
      {/* AI Assistant Widget */}
      <AIAssistantWidget pageContext="calculator" />
    </div>
  );
};

export default InsuranceCalculator;